import axios from "axios";

const createBackendServer = (baseURL) => {
  const api = axios.create({
    baseURL: `${baseURL}/`,

    withCredentials: false,
    headers: {
      Accept: "application/json",
    },
    timeout: 60 * 1000, 
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const message = error?.response?.data?.message;
      error.message = message ?? error.message;
      if (error?.response?.data?.errors) {
        error.errors = error?.response?.data?.errors;
      }
      console.error("API Error:", error); 
      return Promise.reject(error);
    }
  );

  /*==========    GET REQUESTS    ==========*/
  const checktoken = async (params) => {
    try {
      const response = await api.get("/check-token", { params }); return response.data; 
    } catch (err) {
      console.error("Error fetching check-token:", err.message);
      throw err; 
    }
  };
// **************All Token
const alltoken = async (params) => {
  try {
  
    const response = await api.get("/check-token", { 
      params: {
        page: params.page,         
        page_size: params.page_size 
      }
    });
    
    return response.data; 
  } catch (err) {
    console.error("Error fetching check-token:", err.message);
    throw err;
  }
};


// SET PASSWORD
const setPassword = async (body) => {
  try {
    const response = await api.post("/wallet/setPassword", body);
    return response.data;
  } catch (err) {
    console.error("Error fetching setPassword:", err.message);
    throw err;
  }
}


 
// /////////////////////Fetchtop///////////////////////////
  const fetchtop = async (params) => {
    try {
      const response = await api.get("/fetch-top", { params : {
        page: params.page,         
        page_size: params.page_size 
      }

       }); return response.data; 
    } catch (err) {
      console.error("Error fetching check-token:", err.message);
      throw err; 
    }
  };

  const getTokenById = async (tokenAddress, network) => {
    try {
      const response = await api.get(`/get-token-details/${tokenAddress}?network=${network}`); 
      return response.data; 
    } catch (err) {
      console.error("Error fetching check-token:", err.message);
      throw err; 
    }
  };

  // **********************Get Detail**********************************

  
  const getDetails = (tokenAddress, blockchain, network) => {
    return api.get(`/get-token-details/${tokenAddress}?chainid=${blockchain}&network=${network}`);
  };
// ***************************UpcomingIcos***************************
const upcommingico = async (payload) => {
  let params

  if(payload.isSearched) {
    params = {
      tokenName: payload?.tokenName,
      round:payload.round
    }
  } else {
    params = {
      page: payload?.page,
      page_size: payload?.page_size
    }
  }
  
  try {
    const response = await api.get('/api/ico/get-upcoming-icos', { params });
    return response.data; 
  } catch (err) {
    console.error('Error in upcommingico API call:', err.message);
    throw err;
  }
};
//*********************GET-Upcomming******************************** */
const getupcomming = async (id) => {
  try {
   
    const response = await api.get('/api/ico/get-upcomingicos-details/' + id);
    console.log('Response:', response.data); 
    return response.data;
  } catch (err) {
    console.error('Error in upcomingico API call:', err.response?.status, err.message);
    throw err;
  }
};
const getactiveId = async (id) => {
  try {
    
    const response = await api.get('/api/ico/get-aciveicos-details/' + id); 
    console.log('Response:', response.data); 
    return response.data;
  } catch (err) {
    console.error('Error in upcomingico API call:', err.response?.status, err.message);
    throw err;
  }
};


// ***************************ActiveIcos****************************
const activeIco = async (params) => {
  try {
    const response = await api.get('/api/ico/get-active-icos', { params });
    return response.data; 
  } catch (err) {
    console.error('Error in activeIco API call:', err.message);
    throw err;
  }
};
//*******************************Round Seclect Upcomming****************** */
const upcomminground = async (params) => {
  try {
    const response = await api.get('/api/ico/get-upcoming-rounds', { params });
    return response.data; 
  } catch (err) {
    console.error('Error in activeIco API call:', err.message);
    throw err;
  }
};
//*******************************Round Seclect Active****************** */
const activeround = async (params) => {
  try {
    const response = await api.get('/api/ico/get-active-rounds', { params });
    return response.data; 
  } catch (err) {
    console.error('Error in activeIco API call:', err.message);
    throw err;
  }
};
//*******************************new-pools****************** */
const newpools = async (params) => {
  try {
    const response = await api.get('/new-pools');
    return response.data; 
  } catch (err) {
    console.error('Error in activeIco API call:', err.message);
    throw err;
  }
};

//*******************************Get all Favourite****************** */
const allfavourite = async (params) => {
  try {
    const response = await api.get('/get-all-favouruites');
    return response.data; 
  } catch (err) {
    console.error('Error in activeIco API call:', err.message);
    throw err;
  }
};
//*******************************Get all Watchlist****************** */
const watchnew = async () => {
  try {
    const userId = localStorage.getItem("userId"); 
    if (!userId) {
      throw new Error("User ID not found in localStorage.");
    }

    const response = await api.get(`/api/watchlist/get-all-watchlist/${userId}`);
    return response.data;
  } catch (err) {
    console.error("Error in watchnew API call:", err.message);
    throw err;
  }
};
//*******************************Get Ico Detail****************** */

const newico = async (id) => {
  try {
   

    const response = await api.get(`/api/ico/get-ico-details/${id}`);
    return response.data;
  } catch (err) {
    console.error("Error in watchnew API call:", err.message);
    throw err;
  }
};


 /*==========    get-all-listing-fav    ==========*/
 const listing = async () => {
  try {
    const userId = localStorage.getItem("userId"); 
    if (!userId) {
      throw new Error("User ID not found in localStorage.");
    }

    const response = await api.get(`/api/favourite/get-all-favouruites/${userId}`);
    return response.data;
  } catch (err) {
    console.error("Error in watchnew API call:", err.message);
    throw err;
  }
};

  /*==========    POST REQUESTS    ==========*/
  const authLogin = async (body) => api.post("api/user/login", body);
 
//====================create=================
const createwatch = async (body) => {
  try {
    const response = await api.post("api/watchlist/create-watchlist", body);
    return response.data; 
  } catch (error) {
    console.error("Error creating watchlist:", error);
    throw error; // Rethrow or handle the error as necessary
  }
};
/*==========    Add To Favourite    ==========*/
const favourite = async (body) => {
  try {
    // Perform the API request
    const response = await api.post("api/favourite/toggle-favourite", body);
    return response.data; // Return the API response data
  } catch (error) {
    console.error("Error toggling favourite:", error);
    throw error; // Re-throw for higher-level handling
  }
};
/*==========Delete fav==========*/








const deleteWatchlist = async (body) => {
  if (!body || typeof body !== "object") {
    throw new Error("Invalid input: 'body' must be an object.");
  }

  try {
    const response = await api.post("api/watchlist/delete-watchlist", body);
    return response.data;
  } catch (error) {
    console.error("Failed to delete watchlist:", error.message);
    throw new Error("Unable to delete watchlist at this time. Please try again later.");
  }
};


  return {
    authLogin,
    checktoken,
    alltoken, 
    fetchtop,
    getTokenById,
    getDetails,
    activeIco,
    upcommingico,
    getupcomming,
    getactiveId,
    upcomminground,
    setPassword,
    activeround,
    favourite,
    newpools,
    allfavourite,
    createwatch,
    // Delete 
    deleteWatchlist,
    watchnew,
    listing,
    newico,
  };
};

const apis = createBackendServer(process.env.REACT_BACKENDURL || "http://161.35.101.66:5001/");

export default apis;
